import moment from 'moment';

export default class ZoomEventModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.event_type = data.event_type || '';
    this.event_time = data.event_time ? moment(data.event_time).toDate() : null;
    this.was_host = data.was_host || false;
    this.zoom_participant_id = data.zoom_participant_id || null;
    this.zoom_participant_user_id = data.zoom_participant_user_id || null;
  }
}
